import {Component, Input} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {AppState} from '@store/state/app.state';
import {UserService} from '@iw-shop/user/services/user.service';
import {
    getSelectedBillingAddress,
    getSelectedCustomer,
    getSelectedDeliveryAddress
} from '@store/selectors/user.selector';
import {combineLatest, Observable} from 'rxjs';
import {MappedCustomer} from '@store/state/user.state';
import {CustomerAddress} from '@iw-shop/customer/interfaces/customer';
import {take} from 'rxjs/operators';
import {StorageState} from "@store/state/storage.state";

@Component({
    selector: 'iw-shop-customer-addresses-overview',
    standalone: false,
    templateUrl: './customer-addresses-overview.component.html',
    styleUrls: ['./customer-addresses-overview.component.scss']
})
export class CustomerAddressesOverviewComponent {

    @Input() visibilityNewButton: boolean = false;
    @Input() addressVisibility: 'billing' | 'delivery' | 'both' = 'both';

    storage$: Observable<StorageState>;
    selectedCustomer$: Observable<MappedCustomer | undefined>;
    selectedBillingAddress$: Observable<CustomerAddress | undefined>;
    selectedDeliveryAddress$: Observable<CustomerAddress | undefined>;

    editAddress?: {
        addressId?: string,
        addressType: 'billing' | 'delivery',
        activeTab: 'newAddress' | 'updateAddress' | 'selectAddress'
    };

    constructor(protected store: Store<AppState>, private userService: UserService) {
        this.storage$ = this.store.select(state => state.storage);
        this.selectedCustomer$ = this.store.pipe(select(getSelectedCustomer));
        this.selectedBillingAddress$ = this.store.pipe(select(getSelectedBillingAddress));
        this.selectedDeliveryAddress$ = this.store.pipe(select(getSelectedDeliveryAddress));
    }

    countAddresses(): number {
        let value = 0;
        this.selectedCustomer$
            .pipe(take(1))
            .subscribe(
                r => {
                    if (r?.addresses) {
                        value = r.addresses.length;
                    }
                }
            )

        return value
    }


    setEditAddress(type: 'billing' | 'delivery', newAddress: boolean = false) {

        let activeTab: 'newAddress' | 'updateAddress' | 'selectAddress' = 'selectAddress';
        const addresses = this.userService.getSelectedCustomerAddresses({type});
        // Wenn es nur eine Adresse gibt, dann den Tab mit Anlegung einer neuen Adresse öffnen
        if (newAddress) {
            this.editAddress = {addressType: type, activeTab: 'newAddress'};
            return;
        }

        let billingAddressId: string = '';
        let deliveryAddressId: string = '';
        combineLatest([this.store.select(getSelectedDeliveryAddress), this.store.select(getSelectedBillingAddress)])
            .pipe(take(1))
            .subscribe(
                ([deliveryAddress, billingAddress]) => {
                    billingAddressId = billingAddress?.addressId ?? '';
                    deliveryAddressId = deliveryAddress?.addressId ?? '';
                }
            );

        if(type == 'billing'){
            if(addresses.length > 1){
                this.editAddress = {addressType: type, activeTab: 'selectAddress'};
                return;
            } else {
                this.editAddress = {addressType: type, activeTab: 'updateAddress', addressId: billingAddressId};
                return;
            }
        }

        if(type == 'delivery'){
            if(addresses.length > 1){
                this.editAddress = {addressType: type, activeTab: 'selectAddress'};
                return;
            } else if(deliveryAddressId !== billingAddressId &&
                deliveryAddressId.length > 0){
                this.editAddress = {addressType: type, activeTab: 'updateAddress', addressId: deliveryAddressId};
                return;
            } else {
                this.editAddress = {addressType: type, activeTab: 'newAddress'};
                return;
            }
        }

        this.editAddress = {addressType: type, activeTab};
        return;

        /*    if(addresses.length <= 1){

            }
            if (addresses.length > 1) {
              activeTab = 'selectAddress'
            } else if(type == 'delivery'){
                activeTab = 'newAddress';
            }

            let address = this.store.select(getSelectedBillingAddress);
            if (type == 'delivery') {
              address = this.store.select(getSelectedDeliveryAddress);
            }
            address
              .pipe(
                take(1)
              )
              .subscribe(
                r => {
                  if (r) {
                    this.editAddress = {
                      addressId: r.addressId ?? '',
                      addressType: type,
                      activeTab: activeTab
                    };
                  } else {
                    if (addresses.length <= 1) {
                      this.editAddress = {
                        addressType: type,
                        activeTab: 'newAddress'
                      };
                    } else {
                      this.editAddress = {
                        addressType: type,
                        activeTab: activeTab
                      };
                    }

                  }
                }
              )*/
    }
}
